import instance from './config';

const fieldRequestChange = (data) => {
	return instance.post(`/user/field-change-request`, data);
};

export {
	fieldRequestChange
}
